import { connect, ConnectedProps } from 'react-redux';
import { AppState } from '../../../../interfaces';
import { API_KEYS } from '../../../../interfaces/api';
import { getApiState } from '../../../../redux/selectors/common';
import { showModal, hideModal } from '../../../../redux/slices/modal';
import { thunks } from '../../../../redux/thunks/thunks';
import { UserDetails } from './UserDetails';

const mapState = (state: AppState) => ({
  modal: state.modal,
  user: getApiState(state, API_KEYS.LOGIN),
  locations: getApiState(state, API_KEYS.GET_STATIONS),
  serviceCenters: getApiState(state, API_KEYS.GET_SERVICE_CENTERS_BY_STATION),
  activelgas: getApiState(state, API_KEYS.GET_ACTIVE_LGAS),
  homeDeliveryLocations: getApiState(
    state,
    API_KEYS.GET_HOME_DELIVERY_LOCATIONS
  ),
  alphaLoginState : getApiState(state, API_KEYS.ALPHA_LOGIN),
});

const mapDispatch = {
  showModal,
  hideModal,
  getStations: thunks.GET_STATIONS,
  getServiceCenters: thunks.GET_SERVICE_CENTERS_BY_STATION,
  getActiveLgas: thunks.GET_ACTIVE_LGAS,
  getHomeDeliveryLocations: thunks.GET_HOME_DELIVERY_LOCATIONS,
};

const connector = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(UserDetails);


